<template>
    <div class="flex flex-col h-screen overflow-hidden">
        <van-nav-bar :title="matchSubjectName" left-text="返回" left-arrow @click-left="backToPreviousPage" fixed
            class="custom-nav-bar" placeholder />
        <van-pull-refresh class="flex-1 overflow-auto" v-model="loading" @refresh="onRefresh" :head-height="80"
            success-text="刷新成功">
            <div class="p-16 bg-gray-50 relative z-1">
                <MatchScoreTable :data="tableData" :headers="tableHeaders" :user-index="myIndexInReport"
                    v-on:cell-clicked="OnScoreCellClicked">
                </MatchScoreTable>
            </div>
        </van-pull-refresh>
        <van-popup v-model:show="isShowScore" position="center" round closeable close-icon="close"
            :style="{ width: '95%', maxWidth: '600px', padding: '20px' }" class="max-h-90vh overflow-y-auto">
            <div class="w-full">
                <div class="text-lg font-semibold text-gray-800 text-center mb-16">{{ popupTitle }}</div>
                <v-player-score @score-click="onScoreClicked" :show-name="false" :player-index="0"
                    :player-score="playerScore" />
            </div>
        </van-popup>
    </div>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import { showToast } from 'vant';
import { useRoute } from 'vue-router';
import { useRouter } from 'vue-router';
import MatchScoreTable from '@/components/MatchScoreTable.vue';
import msApi from '@/api/match';
import util from '@/global/util';
import vPlayerScore from "@/components/bowling/PlayerScore.vue";
import scoreUtil from '@/global/scoreUtil';
import score from '@/api/score';

// 声明响应式状态
const tableData = ref([]);
const tableHeaders = ref([]);
const loading = ref(false);

// 获取当前路由的查询参数
const route = useRoute();
const router = useRouter();
const matchSubjectId = route.query.id;
const reportObj = ref([]);
const matchSubjectName = ref('比赛分数');
const playerScore = ref(null);
const isShowScore = ref(false);
const scoreReplays = ref([]);
const popupTitle = ref('详细得分');
const myInfoInMatchSubject = ref(null);
const myIndexInReport = ref([]);

// 在组件挂载时获取数据


onMounted(async () => {
    await getMyInfoInMatchSubject();
    await fetchMatchSubjectData();
    // findMyIndexInReport 已在 fetchMatchSubjectData 中调用
});

const getMyInfoInMatchSubject = async () => {
    try {
        let myInfo = await msApi.getMyInfoInMatchSubject(matchSubjectId);
        myInfoInMatchSubject.value = myInfo;
    } catch (error) {
        console.error('Failed to fetch my match bowler info:', error);
        showToast('获取我的比赛信息失败');
    }
}

const findMyIndexInReport = async () => {
    if (!myInfoInMatchSubject.value || !myInfoInMatchSubject.value.id || !tableData.value) {
        myIndexInReport.value = [];
        return [];
    }

    const myId = myInfoInMatchSubject.value.id;
    const indices = [];

    // 遍历所有行，找出所有匹配的索引
    tableData.value.forEach((row, index) => {
        if (row.bowlerOrTeamId === myId) {
            indices.push(index);
        }
    });

    myIndexInReport.value = indices;
    return indices;
}

const fetchMatchSubjectData = async () => {
    if (!matchSubjectId) {
        console.error('No match ID provided in query parameters.');
        showToast('未提供比赛ID');
        return;
    }

    try {
        let matchSubjectInfo = await msApi.getMatchSubjectBasicInfo(matchSubjectId);
        let reportInUi = await getReportInUI(matchSubjectInfo);
        reportObj.value = reportInUi;
        tableHeaders.value = reportInUi.headers;
        tableData.value = reportInUi.reportRowInfos;
        matchSubjectName.value = reportInUi.report.matchSubjectName;
        // 数据加载完成后立即查找用户索引
        await findMyIndexInReport();
    } catch (error) {
        console.error('Failed to fetch match subject report:', error);
        showToast('获取比赛数据失败');
    }
};

const getReportInUI = async (matchSubjectInfo) => {
    if (matchSubjectInfo.matchItemType === 20) {
        let reportInUi = await msApi.MatchSubjectBowlerScoreInTeamReportWithRankInUI(matchSubjectId);
        return reportInUi;
    }
    else {
        let reportInUi = await msApi.MatchSubjectSessionsBowlerScoreInTeamReportWithRankInUI(matchSubjectId);
        return reportInUi;
    }
};

const onRefresh = async () => {
    try {
        await fetchMatchSubjectData();
        showToast({
            message: '刷新成功',
            type: 'success',
            position: 'top',
        });
    } catch (error) {
        showToast({
            message: '刷新失败',
            type: 'fail',
            position: 'top',
        });
    } finally {
        loading.value = false;
    }
};
const OnScoreCellClicked = ({ rowIndex, colIndex, cellValue }) => {
    if (!cellValue || util.isBlank(cellValue.scoreId)) return;

    // 获取表头和第二列的内容（添加防护检查）
    let headerTitle = '详细得分';
    let secondColumnValue = '';

    try {
        if (tableHeaders.value &&
            tableHeaders.value[colIndex] &&
            tableHeaders.value[colIndex].text) {
            headerTitle = tableHeaders.value[colIndex].text;
        }

        if (tableData.value &&
            tableData.value[rowIndex] &&
            tableData.value[rowIndex].rowScoreInfos &&
            tableData.value[rowIndex].rowScoreInfos[1] &&
            tableData.value[rowIndex].rowScoreInfos[1].text) {
            secondColumnValue = tableData.value[rowIndex].rowScoreInfos[1].text;
        }
    } catch (error) {
        console.warn('获取表格信息失败:', error);
    }

    showScore(cellValue.scoreId, headerTitle, secondColumnValue);
};

const onScoreClicked = (playIndex, roundIndex, scoreIndex) => {
    console.info("score is clicked " + playIndex + " " + roundIndex + " " + scoreIndex);
    let roundNumber = roundIndex + 1;
    let strikeNumber = scoreIndex + 1;
    if (util.isBlank(scoreReplays.value)) return;
    const scoreReplay = scoreReplays.value.find(item =>
        item.roundNumber === roundNumber && item.strikeNumber === strikeNumber
    );
    if (util.isBlank(scoreReplay)) return;
    if (util.isBlank(scoreReplay.urlDict)) return;

};


const showScore = async (scoreId, headerTitle, secondColumnValue) => {
    let matchScore = await msApi.GetMatchScore(scoreId);
    //scoreReplays.value = await score.getMatchScoreReplays(scoreId);
    console.info(scoreReplays);
    playerScore.value = scoreUtil.convertToUIScore(matchScore);
    popupTitle.value = `${secondColumnValue} - ${headerTitle}`;
    isShowScore.value = true;
};

const backToPreviousPage = () => {
    router.back();
};
</script>

<style scoped>
:deep(.van-pull-refresh) {
    @apply h-full block;
}

:deep(.van-pull-refresh__track) {
    @apply block pb-16;
    min-height: unset !important;
}

:deep(.van-pull-refresh__content) {
    @apply block;
}

:deep(.van-loading),
:deep(.van-pull-refresh__text) {
    @apply text-primary;
}

:deep(.van-popup__close-icon) {
    @apply text-gray-800 text-xl p-16;
}

/* 表格容器 */
:deep(.table-container) {
    @apply w-full;
}
</style>